import React from 'react';
import 'twin.macro';
import FadeInComponent from '@teetsh/app/src/components/Transitions/FadeIn';
import clsx from 'clsx';
import Tooltip2 from '@teetsh/app/src/components/Tooltip2';
import { SparklesIcon } from '@heroicons/react/24/outline';

interface Props {
  onChange: (v: string) => void;
  value: string;
  className?: string;
}

export function SuggestionItem(props: Props) {
  const { onChange, value } = props;
  return (
    <div
      className={clsx(props.className, 'group')}
      // Le coup du -my-3 py-1.5 c'est pour que le composant prenne la hauteur totale de la suggestion, pour éviter que le hover blink en déscendant sur l'élément
      tw="min-w-0 justify-start items-center text-neutral-quiet -my-3 py-1.5 text-xs hover:text-neutral-moderate"
    >
      <FadeInComponent delay={100}>
        <Tooltip2
          delay={1000}
          label={<div tw="max-w-xs text-wrap">{value}</div>}
          tw="flex shrink min-w-0 justify-start items-center"
        >
          <div
            tw="p-1 cursor-pointer inline-flex items-center rounded-md border border-dashed border-neutral-quiet hover:border-neutral-moderate"
            onClick={e => {
              e.stopPropagation();
              onChange(value);
            }}
          >
            <SparklesIcon tw="shrink-0 h-4 w-4 mr-1" />
            <span tw="truncate min-w-0">{value}</span>
          </div>
        </Tooltip2>
      </FadeInComponent>
    </div>
  );
}
